var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelsnotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87491 3.3542C1.8721 3.15917 1.90844 2.96557 1.98178 2.78484C2.05513 2.60411 2.16398 2.43993 2.30189 2.30201C2.43981 2.1641 2.60399 2.05525 2.78472 1.98191C2.96545 1.90857 3.15905 1.87222 3.35407 1.87503L9.59407 1.9542C10.1929 1.96144 10.7651 2.20283 11.1882 2.6267L17.2707 8.70836C17.6232 9.06086 17.9357 9.57003 18.0641 10.1142C18.1941 10.6675 18.1441 11.3442 17.6232 11.8642L11.8649 17.6234C11.3441 18.1442 10.6674 18.1942 10.1141 18.0642C9.58272 17.9308 9.0971 17.6568 8.70824 17.2709L2.62657 11.1884C2.20346 10.7648 1.9622 10.1929 1.95407 9.59419L1.87491 3.3542ZM6.53491 5.26253C6.41643 5.15213 6.25972 5.09203 6.09781 5.09488C5.93589 5.09774 5.7814 5.16333 5.66689 5.27784C5.55238 5.39235 5.48678 5.54684 5.48393 5.70876C5.48107 5.87068 5.54117 6.02738 5.65157 6.14586L6.24074 6.73586C6.35867 6.84966 6.51658 6.91258 6.68045 6.91108C6.84432 6.90958 7.00105 6.84377 7.11688 6.72784C7.2327 6.6119 7.29836 6.45511 7.29971 6.29124C7.30105 6.12737 7.23798 5.96952 7.12407 5.8517L6.53491 5.26253Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelsnotactive);
export default __webpack_public_path__ + "static/media/labelsnotactive.881af1495d37caba277973fe7734fd95.svg";
export { ForwardRef as ReactComponent };